import img1A from '../images/profile/1A.png';
import img1B from '../images/profile/1B.png';
import img2A from '../images/profile/2A.png';
import img2B from '../images/profile/2B.png';
import img3A from '../images/profile/3A.png';
import img3B from '../images/profile/3B.png';
import img4A from '../images/profile/4A.png';
import img4B from '../images/profile/4B.png';
import img5A from '../images/profile/5A.png';
import img5B from '../images/profile/5B.png';
import img6A from '../images/profile/6A.png';
import img6B from '../images/profile/6B.png';
import img7A from '../images/profile/7A.png';
import img7B from '../images/profile/7B.png';

export const PROFILE_IMAGES = [
    img1A, img1B, img2A, img2B,
    img3A, img3B, img4A, img4B,
    img5A, img5B, img6A, img6B,
    img7A, img7B,
];

export const CHAR_SCALES = [
    1.081, // 1A
    1.049, // 1B
    0.880, // 2A
    0.899, // 2B
    0.880, // 3A
    1.048, // 3B
    0.962, // 4A
    1.076, // 4B
    0.880, // 5A
    0.990, // 5B
    1.497, // 6A — overweight character, wide PNG
    1.182, // 6B
    0.925, // 7A
    0.880, // 7B
];
